import '../Styles/Loading.css';
import React from '../Img/reactLogo.png';

function Loading() {

  return (

    <div className="Loading">
      <img src={React} alt="" />
    </div>

  );
}

export default Loading;